import { CategoryCellFormatter } from "components/grid/cell-formatters/category-cell-formatter";
import { PaymentTypeCellFormatter } from "components/grid/cell-formatters/payment-type-cell-formatter";
import { ViewedCellFormatter } from "components/grid/cell-formatters/viewed-cell-formatter";
import { DownloadUrlCellFormatter } from "components/grid/cell-formatters/download-url-cell-formatter";
import { UploadSourceCellFormatter } from "components/grid/cell-formatters/upload-source-cell-formatter";
import { MoneyCellFormatter, SimpleMoneyCellFormatter } from "components/grid/cell-formatters/money-cell-formatter";
import { DateCellFormatter, SimpleDateCellFormatter } from "components/grid/cell-formatters/date-cell-formatter";
import { TimeCellFormatter } from "components/grid/cell-formatters/time-cell-formatter";
import { NameCellFormatter } from "components/grid/cell-formatters/name-cell-formatter";
import { SelectCellFormatter } from "components/grid/cell-formatters/select-cell-formatter";
import { AttachmentCellFormatter } from "components/grid/cell-formatters/attachment-cell-formatter";

export const columnObjects = [
  {
    key: "select",
    name: "Select",
    visible: true,
    fixedWidth: 40,
    width: 0
  },
  {
    key: "type",
    name: "Type",
    visible: true,
    fixedWidth: 40,
    width: 0
  },
  {
    key: "vendor",
    name: "Vendor/Name",
    resizable: true,
    sortable: true,
    visible: true,
    width: 0.15
  },
  {
    formatter: DateCellFormatter,
    key: "issued",
    name: "Date",
    resizable: true,
    sortable: true,
    visible: true,
    fixedWidth: 80,
    width: 0
  },
  {
    formatter: MoneyCellFormatter,
    key: "total",
    name: "Total",
    resizable: true,
    sortable: true,
    visible: true,
    width: 0.15
  },
  {
    formatter: MoneyCellFormatter,
    key: "tax",
    name: "Tax",
    resizable: true,
    sortable: true,
    visible: true,
    width: 0.10
  },
  {
    formatter: CategoryCellFormatter,
    key: "categories",
    name: "Category",
    resizable: true,
    visible: true,
    width: 0.4
  },
  {
    key: "invoiceNumber",
    name: "Invoice #",
    resizable: true,
    visible: false,
    width: 0.1
  },
  {
    formatter: PaymentTypeCellFormatter,
    key: "paymentType",
    name: "Payment type",
    resizable: true,
    sortable: true,
    visible: false,
    width: 0.1
  },
  {
    formatter: TimeCellFormatter,
    key: "uploaded",
    name: "Uploaded",
    resizable: true,
    sortable: true,
    visible: true,
    fixedWidth: 70,
    width: 0
  },
  {
    formatter: DownloadUrlCellFormatter,
    key: "downloadUrl",
    name: "DL",
    resizable: true,
    visible: false,
    fixedWidth: 40,
    width: 0
  },
  {
    formatter: UploadSourceCellFormatter,
    key: "source",
    name: "Source",
    resizable: true,
    visible: false,
    fixedWidth: 55,
    width: 0
  }
];

export const otherDocsColumnObjects = [
  {
    key: "select",
    visible: true
  },
  {
    formatter: NameCellFormatter,
    key: "name",
    name: "Name",
    resizable: true,
    sortable: true,
    visible: true,
    width: 200
  },
  {
    formatter: DateCellFormatter,
    key: "issued",
    name: "Date",
    resizable: true,
    sortable: true,
    visible: true,
    width: 150
  },
  {
    key: "notes",
    name: "Notes",
    resizable: true,
    sortable: false,
    visible: true
  },
  {
    formatter: TimeCellFormatter,
    key: "uploaded",
    name: "Uploaded at",
    resizable: true,
    sortable: true,
    visible: true
  },
  {
    formatter: ViewedCellFormatter,
    key: "viewed",
    name: "Viewed",
    resizable: true,
    sortable: true,
    visible: true
  },
  {
    formatter: DownloadUrlCellFormatter,
    key: "downloadUrl",
    name: "Download",
    resizable: true,
    sortable: false,
    visible: true
  },
  {
    formatter: UploadSourceCellFormatter,
    key: "source",
    name: "Upload Source",
    resizable: true,
    sortable: true,
    visible: true
  }
];

export const mergeDocumentsColumnObjects = [
  {
    formatter: SelectCellFormatter,
    key: "isSelected",
    name: ""
  },
  {
    formatter: AttachmentCellFormatter,
    key: "attachment",
    name: "Image"
  },
  {
    key: "vendor",
    name: "Vendor"
  },
  {
    formatter: SimpleDateCellFormatter,
    key: "issued",
    name: "Date"
  },
  {
    formatter: SimpleMoneyCellFormatter,
    getRowMetaData: (row) => row,
    key: "total",
    name: "Total"
  },
  {
    key: "currency",
    name: "Currency"
  },
  {
    formatter: SimpleMoneyCellFormatter,
    key: "tax",
    name: "Tax"
  },
  {
    formatter: CategoryCellFormatter,
    key: "categories",
    name: "Category"
  },
  {
    key: "invoiceNumber",
    name: "Invoice #"
  },
  {
    formatter: PaymentTypeCellFormatter,
    key: "paymentType",
    name: "Payment type"
  }
];

export const mergeOtherDocumentsColumnObjects = [
  {
    formatter: SelectCellFormatter,
    key: "isSelected",
    name: ""
  },
  {
    formatter: AttachmentCellFormatter,
    key: "attachment",
    name: "Image"
  },
  {
    key: "name",
    name: "Name"
  },
  {
    formatter: DateCellFormatter,
    key: "issued",
    name: "Date"
  }
];



// WEBPACK FOOTER //
// ./src/js/components/grid/column-objects.jsx